import { useCallback, useEffect, useRef } from 'react'

const LS_KEY = 'vertex.chat.threadW'
export const THREAD_W_DEFAULT = 380
export const THREAD_W_MIN = 280
export const THREAD_W_MAX = 560

export function loadThreadWidth(fallback = THREAD_W_DEFAULT) {
  try {
    const v = Number(localStorage.getItem(LS_KEY))
    if (v >= THREAD_W_MIN && v <= THREAD_W_MAX) return v
  } catch { /* ignore */ }
  return fallback
}

export function saveThreadWidth(w) {
  try { localStorage.setItem(LS_KEY, String(Math.round(w))) } catch { /* ignore */ }
}

/** Teams tarzı sürükle-boyutlandır ayırıcı — sol (ana sohbet) / sağ (konu) arasında. */
export default function ThreadResizeHandle({ width, onChange, onDragEnd, className = '' }) {
  const drag = useRef(null)

  const onMove = useCallback((e) => {
    const d = drag.current
    if (!d) return
    // Sağa sürükleyince konu paneli daralır (sağ kenar sabit gibi)
    const next = Math.min(THREAD_W_MAX, Math.max(THREAD_W_MIN, d.startW - (e.clientX - d.startX)))
    onChange(next)
  }, [onChange])

  const onUp = useCallback(() => {
    if (!drag.current) return
    drag.current = null
    document.body.style.cursor = ''
    document.body.style.userSelect = ''
    onDragEnd?.()
  }, [onDragEnd])

  useEffect(() => {
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    window.addEventListener('pointercancel', onUp)
    return () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', onUp)
      window.removeEventListener('pointercancel', onUp)
    }
  }, [onMove, onUp])

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-valuenow={Math.round(width)}
      aria-valuemin={THREAD_W_MIN}
      aria-valuemax={THREAD_W_MAX}
      title="Sürükleyerek konuyu genişlet / daralt"
      onPointerDown={(e) => {
        e.preventDefault()
        drag.current = { startX: e.clientX, startW: width }
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
      }}
      className={`group relative w-1.5 shrink-0 cursor-col-resize bg-transparent hover:bg-violet-200/80 active:bg-violet-300/90 transition-colors ${className}`}
    >
      <span className="pointer-events-none absolute inset-y-0 -left-1 -right-1" />
      <span className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                       w-1 h-8 rounded-full bg-gray-300 group-hover:bg-violet-500 group-active:bg-violet-600 transition-colors" />
    </div>
  )
}
